<app-menu-common url="sales"></app-menu-common>

<div class="rentals-page">
  <!-- ══════════════════════════════════════════════════════════════════════════
  SÉLECTEUR — Titre, Client, Statut Location, Magasin, Nb réponses, Actions
  ══════════════════════════════════════════════════════════════════════════ -->
  <div class="toolbar-card">
    <div class="toolbar-title">
      <mat-icon class="toolbar-icon">event_repeat</mat-icon>
      <span>Locations</span>
    </div>

    <div class="filters-inline">
      <div class="filter-item partner-filter">
        <label class="filter-label">Client facturé (tiers facturé)</label>
        <app-search-partner [currentPartner]="customer" width="280px" [showSelectionInInput]="true" (partnerChange)="customerChange($event)"></app-search-partner>
      </div>

      <div class="filter-item status-filter-item">
        <label class="filter-label" for="flt-status">Statut</label>
        <mat-select id="flt-status" class="custom-select state-select" [(ngModel)]="selectedStatuses" (selectionChange)="onRentalStatusChange()" multiple [placeholder]="selectedStatusesLabel">
          @for (s of availableStatuses; track s.value) {
          <mat-option [value]="s.value">{{ s.label }}</mat-option>
          }
        </mat-select>
      </div>

      <div class="filter-item">
        <label class="filter-label" for="flt-store">Magasin&nbsp;/&nbsp;Ets.</label>
        <select id="flt-store" class="custom-select store-select" [(ngModel)]="filter.store" (change)="onSearch()">
          @for (store of stores; track store) {
          <option [value]="store.id">{{store.name}}&nbsp;{{ (store.id ?? 0) > 0 ? store.id : '' }}</option>
          }
        </select>
      </div>

      <div class="filter-item">
        <label class="filter-label" for="flt-limit" title="Nombre de réponses">Nb&nbsp;rép.</label>
        <select id="flt-limit" class="custom-select limit-select" [(ngModel)]="filter.limit" (change)="onSearch()">
          @for (val of limitsValue; track val) {
          <option [value]="val">{{ limitLabel(val) }}</option>
          }
        </select>
      </div>
      <label class="filter-item hide-returned" matTooltip="Ne pas lire les matériels déjà repris (BL de reprise signé)">
        <input id="flt-hide-returned" type="checkbox" [(ngModel)]="hideReturned" (change)="onSearch()" />
        <span>Masquer les repris</span>
      </label>
      <app-dossiers-incertains></app-dossiers-incertains> <!-- DOSSIERS INCERTAINS DE LA MIGRATION, TEMPORAIRE (documentation.html#front.rental.dossiers-incertains) -->
    </div>

    <div class="toolbar-actions">
      @if (customer?.id) {
        <a mat-stroked-button class="btn-inline btn-ghost" [routerLink]="['/rental/payeur', customer?.id]" aria-label="Tous les dossiers de ce client" title="Tous les dossiers de location de ce client sur une même page">
          <mat-icon>folder_shared</mat-icon>
        </a>
      }
      <button mat-stroked-button class="btn-inline btn-ghost" aria-label="Actualiser" title="Relancer la recherche" (click)="onSearch()">
        <mat-icon [class.spinning]="is_loading">refresh</mat-icon>
      </button>
      <button mat-flat-button class="error btn-inline" aria-label="Effacer" title="Réinitialiser les filtres" (click)="onCancel()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>

  <!-- ══════════════════════════════════════════════════════════════════════════
  TABLEAU : Liste des contrats de location + lignes sous chaque contrat
  ══════════════════════════════════════════════════════════════════════════ -->
  <div class="content-row">
    <div class="table-card">
      <!-- Barre de la carte : identité, compteur, sélection en lot et action facturer -->
      <div class="table-header-bar">
        <div class="header-left">
          <div class="table-title">
            <mat-icon>receipt_long</mat-icon>
            <span>Contrats de location</span>
            <span class="badge-count">{{ displayedOrders.length }}</span>
          </div>

          <div class="batch-actions">
            <button mat-button color="primary" class="btn-batch" (click)="selectAllOrders()" [disabled]="displayedOrders.length === 0">
              <mat-icon>select_all</mat-icon>
              Tout sélectionner
            </button>
            <button mat-button class="btn-batch" (click)="deselectAllOrders()" [disabled]="selectedOrderIds.size === 0">
              <mat-icon>deselect</mat-icon>
              Désélectionner
            </button>
            <button mat-button color="primary" class="btn-batch btn-fold-all" (click)="toggleCollapseAll()" [disabled]="displayedOrders.length === 0">
              <mat-icon>{{ allCollapsed() ? 'expand_more' : 'expand_less' }}</mat-icon>
              {{ allCollapsed() ? 'Déplier tous les dossiers' : 'Replier tous les dossiers' }}
            </button>
            @if (selectedOrderIds.size > 0) {
            <span class="selection-badge"> {{ selectedOrderIds.size }} sélectionnée{{ selectedOrderIds.size > 1 ? 's' : '' }} </span>
            }
          </div>
        </div>

        <div class="header-right">
          <div class="validation-content">
            <button mat-flat-button color="primary" class="validate-button" (click)="onInvoice()" [disabled]="selectedOrderIds.size === 0">
              <mat-icon>receipt_long</mat-icon>
              <span>Facturer</span>
            </button>
            @if (selectedOrderIds.size === 0) {
            <div class="validation-hint">
              <span>Sélectionner des locations</span>
            </div>
            } @if (selectedOrderIds.size > 0) {
            <div class="validation-hint success">
              <span>{{ selectedOrderIds.size }} location{{ selectedOrderIds.size > 1 ? 's' : '' }} &bull; {{ getSelectedTotal() | number:'1.2-2' }}&nbsp;€</span>
            </div>
            }
          </div>
        </div>
      </div>

      <div class="table-orders">
        <!-- Entête de liste -->
        <div class="order-line entete">
          <div class="cell fold-cell"></div>
          <div class="cell select-cell">
            <mat-checkbox [checked]="isAllSelected()" [indeterminate]="isPartiallySelected()" (change)="toggleSelectAll()" color="primary" matTooltip="Tout sélectionner / désélectionner"> </mat-checkbox>
          </div>
          @for (col of displayedColumnsInfo; track col[0]) {
          <div [class]="'cell ' + col[0] + '-cell ' + col[2]" [matTooltip]="colSortHint(col[0])" matTooltipClass="tooltip-multiline" (click)="sortOrders((col[3] === undefined ? true : (col[3] === true ? false : true)), col[0])" style="cursor: pointer"> <span class="sort-arrow">{{ col[3] === undefined ? '' : (col[3] === true ? '&#8593;' : '&#8595;') }}</span> {{ col[1] }} </div>
          }
        </div>

        @if (displayedOrders.length > 0) { @for (o of displayedOrders; track o.id; let isEven = $even) { @let sublines = getRentalLines(o);
        @let folded = isCollapsed(o.id);
        <div class="order-wrapper" [ngClass]="[isEven ? 'even' : 'odd', sublines.length > 0 && !folded ? 'has-sublines' : 'no-sublines']" [class.selected]="isOrderSelected(o.id)" [class.is-canceled]="o.state === SalesOrderState.CANCELED" [class.is-folded]="folded">
          <!-- Ligne parent (contrat) cliquable -->
          <a class="order-line unstyled-link" [routerLink]="dossierLink(o)" [queryParams]="{ vue: 'planning' }" target="_blank">
            <div class="cell fold-cell">
              @if (sublines.length > 0) {
              <button type="button" mat-icon-button class="fold-btn" [attr.aria-expanded]="!folded" [matTooltip]="folded ? 'Déplier le dossier' : 'Replier le dossier'" (click)="toggleCollapse(o.id, $event)">
                <mat-icon>{{ folded ? 'expand_more' : 'expand_less' }}</mat-icon>
              </button>
              }
            </div>
            <div class="cell select-cell" (click)="$event.stopPropagation()">
              @if (o.state !== SalesOrderState.CANCELED) {
              <mat-checkbox [checked]="isOrderSelected(o.id)" (change)="toggleOrderSelection(o.id)" color="primary"> </mat-checkbox>
              } @else {
              <mat-icon class="canceled-cell-icon" matTooltip="Contrat annulé (inactif) — non facturable">block</mat-icon>
              }
            </div>
            @for (col of displayedColumnsInfo; track col[0]) {
            <div [class]="'cell ' + col[0] + '-cell ' + col[2]">
              @if (col[0] === 'id') { {{ o.id }} } @else if (col[0] === 'datecre') { {{ $safeNavigationMigration(o.dates?.created) | date:'dd/MM/yy HH:mm':'Local' }} } @else if (col[0] === 'store') { {{ o.lnk_station?.store }} } @else if (col[0] === 'status') {
              <span class="state-pill" [ngClass]="getColor(o.state)">{{ getLabel(o.state) }}</span>
              @if (o.state === SalesOrderState.CANCELED) {
              <span class="inactive-badge" matTooltip="Contrat annulé sans exécution">Inactif</span>
              } } @else if (col[0] === 'beneficiary') { @let b = beneficiaryName(o); <span class="party-band beneficiary" [title]="(payerIsBeneficiary(o) ? 'Livré chez et facturé à : ' : 'Livré chez : ') + b">{{ b }}</span> } @else if (col[0] === 'customer') { @if (!payerIsBeneficiary(o)) { @let p = payerName(o); <span class="party-band payer" [title]="'Facturé à : ' + p">{{ p }}</span> } } @else if (col[0] === 'amount_taxi') { {{ o.amount_taxi | number:'1.2-2' }} } @else if (col[0] === 'amount_remainer') { @if (getRemainer(o) !== 0) { {{ getRemainer(o) | number:'1.2-2' }} } }
            </div>
            }
          </a>

          <!-- Lignes de location rattachées, visibles sous le contrat parent tant qu'il n'est pas replié -->
          @if (sublines.length > 0 && !folded) {
          <div class="sublines-container">
            <div class="sublines-table">
              <div class="subline-header">
                <span class="subline-col-product">Article / Matériel</span>
                <span class="subline-col-contract">Contrat</span>
                <span class="subline-col-qty" matTooltip="Quantité de l'article loué">Qté</span>
                <span class="subline-col-duration" matTooltip="Durée totale prévue par la prescription (en unités de période)">Durée</span>
                <span class="subline-col-progress">Avancement</span>
                <span class="subline-col-state">État</span>
                <span class="subline-col-price">Montant</span>
              </div>
              @for (sl of sublines; track sl.id ?? sl.seq) {
              <div class="subline-row" [class.subline-expired]="isLineExpired(o, sl)" [class.subline-sale]="!isRentalLine(sl)">
                <span class="subline-col-product" [title]="sl.product_name || ''">
                  <mat-icon class="subline-icon">subdirectory_arrow_right</mat-icon>
                  <span class="subline-product-text">
                    <span class="subline-product-name">{{ sl.product_name }}</span>
                    @if (sl.memo) {
                    <span class="subline-line-memo" [title]="sl.memo">{{ sl.memo }}</span>
                    }
                  </span>
                </span>
                <span class="subline-col-contract">
                  @if (getContractName(sl)) {
                  <span class="contract-chip">{{ getContractName(sl) }}</span>
                  } @else {
                  <span class="contract-empty">—</span>
                  }
                </span>
                <span class="subline-col-qty">{{ sl.qty }}</span>
                <span class="subline-col-duration">{{ durationLabel(sl) }}</span>
                <span class="subline-col-progress">
                  @if (isRentalLine(sl)) { @let lc = lifecycles.get(o.id); @if (getLifecycleProgress(o, sl)) {
                  <span class="progress-text" [class.progress-done]="isLineExpired(o, sl)" matTooltip="Rangs facturés nets / Durée (registre des factures filles)"> {{ getLifecycleProgress(o, sl) }} </span>
                  @if (isLineExpired(o, sl)) {
                  <span class="expiry-badge" [matTooltip]="daysSinceExpiry(o, sl) !== null ? 'Durée atteinte depuis ' + daysSinceExpiry(o, sl) + ' j' : 'Durée atteinte'"> @if (daysSinceExpiry(o, sl) !== null) { +{{ daysSinceExpiry(o, sl) }} j } @else { Expiré } </span>
                  } @if (lc?.loading) {
                  <mat-progress-spinner class="progress-refresh" mode="indeterminate" diameter="12" strokeWidth="2" matTooltip="Avancement en cours de relecture"></mat-progress-spinner>
                  } @else if (lc?.error) {
                  <button type="button" mat-icon-button class="progress-load-btn" [matTooltip]="'Relecture en échec : ' + lc?.error + ' — cliquer pour réessayer'" (click)="loadLifecycle(o, $event)"><mat-icon>error_outline</mat-icon></button>
                  } } @else if (lc?.loading) {
                  <mat-progress-spinner mode="indeterminate" diameter="14" strokeWidth="2"></mat-progress-spinner>
                  } @else if (lc?.view) {
                  <span class="contract-empty">—</span>
                  } @else {
                  <button type="button" mat-icon-button class="progress-load-btn" [matTooltip]="lc?.error ? 'Échec : ' + lc?.error + ' — cliquer pour réessayer' : 'Calculer l\'avancement du dossier'" (click)="loadLifecycle(o, $event)">
                    <mat-icon>{{ lc?.error ? 'error_outline' : 'calculate' }}</mat-icon>
                  </button>
                  } } @else { @if (sl.is_invoiced) {
                  <span class="badge-status-invoiced" matTooltip="Article annexe déjà facturé sur une facture fille">
                    <mat-icon class="status-badge-icon">check</mat-icon>
                    Facturé
                  </span>
                  } @else {
                  <span class="badge-status-to-invoice" matTooltip="Article annexe en attente de facturation">
                    <mat-icon class="status-badge-icon">schedule</mat-icon>
                    À facturer
                  </span>
                  } }
                </span>
                <!-- Statut du moteur une fois le cycle du dossier chargé (bouton de la colonne Avancement) ; rien n'est déduit ici. -->
                <span class="subline-col-state">
                  @if (isRentalLine(sl)) { @let st = lineState(o, sl); @if (st) {
                  <span [class]="st.cls">{{ st.label }}</span>
                  @if (st.interrupted) {
                  <span class="pill st-interrupted">{{ INTERRUPTED_BADGE }}</span>
                  } @if (st.anomalies) {
                  <span class="anomaly-mark" [matTooltip]="st.anomalies" matTooltipClass="tooltip-multiline" aria-label="Anomalies de la ligne">⚠</span>
                  } } }
                </span>
                <span class="subline-col-price">{{ (sl.uprice_taxi ?? sl.net_taxi) | number:'1.2-2' }} €</span>
              </div>
              }
            </div>
            <!-- Pas de lien « Page du dossier » ici : la rangée du dossier y mène déjà. -->
            @if (orderAnomalies(o).length) {
            <div class="dossier-extra">
              <ul class="dossier-anomalies">
                @for (a of orderAnomalies(o); track $index) {
                <li><mat-icon class="dossier-anomaly-icon">warning</mat-icon>{{ a }}</li>
                }
              </ul>
            </div>
            }
          </div>
          }
        </div>
        } } @else if (is_loading) {
        <div class="loading-orders" style="grid-column: 1 / -1">
          <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="4" color="primary"></mat-progress-spinner>
          <span>Chargement des locations…</span>
        </div>
        } @else {
        <div class="empty-orders" style="grid-column: 1 / -1">
          <mat-icon class="empty-icon">event_repeat</mat-icon>
          <div class="empty-title">Aucune location</div>
          <div class="empty-subtitle">Aucun contrat de location ne correspond aux filtres courants.</div>
          <button mat-stroked-button color="primary" class="action-btn" (click)="onCancel()">
            <mat-icon>clear</mat-icon>
            Réinitialiser les filtres
          </button>
        </div>
        }
      </div>
    </div>
  </div>
</div>
